/**
 * Creates HTTP headers from trace context.
 *
 * @param traceId - The trace ID
 * @param spanId - The span ID
 * @returns An object containing HTTP headers to add to outgoing requests in order to propagate the trace context
 */
export function makeTraceHttpHeaders(traceId: string, spanId: string): Record<string, string> {
	return { 'X-B3-TraceId': traceId, 'X-B3-SpanId': spanId };
}
